module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-lukas.b09d473d.jpg";